import { Module } from "@apis/index";
import { deletesvg, edit, switchOff, switchOn } from "@assets/icons";
import DeleteModal from "@components/delete-modal";
import Button from "@components/button";
import Row from "@components/row";
import Svg from "@components/svg";
import Table from "@components/table";
import Title from "@components/title";
import useConfig from "@hooks/useConfig";
import { useModal } from "@context/ModalContext";
import { RootState } from "@store/index";
import { Plus } from "lucide-react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, ModuleIcon, ModuleName } from "./styles";

const ModuleList = () => {
  const { bucketUrl } = useConfig();
  const { showModal } = useModal();

  const { data: modules } = useSelector((state: RootState) => state.modules);
  console.log(modules, "modules");
  const fetchModules = async () => {
    await Module.list({
      state: "modules",
      params: { limit: 20 },
    });
  };

  useEffect(() => {
    fetchModules();
  }, []);

  const columns = [
    {
      title: "ID",
      key: "id",
      render: (item: any) => item.id,
    },
    {
      title: "Module",
      key: "module",
      render: (item: any) => <ModuleName>{item.name}</ModuleName>,
    },
    {
      title: "Icon",
      key: "icon",
      render: (item: any) => {
        const iconName =
          item?.name === "Any Services"
            ? "anyservicetitle"
            : `${item?.name?.toLowerCase()}title`;

        const iconSrc = item.icon
          ? `${bucketUrl}/${item.icon}`
          : `/svgs/${iconName}${item.icon?.endsWith(".png") ? ".png" : ".svg"}`;
        return <ModuleIcon src={iconSrc} alt={item.name} />;
      },
    },
    {
      title: "Illustration",
      key: "illustration",
      render: (item: any) => {
        const illustrationSrc = item.illustration
          ? `${bucketUrl}/${item.illustration}`
          : null;
        return illustrationSrc ? (
          <ModuleIcon src={illustrationSrc} alt="Illustration" />
        ) : (
          "-"
        );
      },
    },
    {
      title: "Type",
      key: "type",
      render: (item: any) => item.type,
    },
    {
      title: "Active",
      key: "isActive",
      render: (item: any) => (
        <Svg
          src={item.isActive ? switchOn : switchOff}
          onClick={async () => {
            const formdata = new FormData();
            const payload = item.isActive ? "false" : "true";
            formdata.append("isActive", payload);
            await Module.update({
              state: "modules",
              id: item.id,
              data: formdata,
            });
          }}
        />
      ),
    },
    {
      title: "Is Module",
      key: "isModule",
      render: (item: any) => (
        <Svg
          src={item.isModule ? switchOn : switchOff}
          onClick={async () => {
            const formdata = new FormData();
            const payload = item.isModule ? "false" : "true";
            formdata.append("isModule", payload);
            await Module.update({
              state: "modules",
              id: item.id,
              data: formdata,
            });
          }}
        />
      ),
    },
  ];
  const navigate = useNavigate();
  return (
    <Container>
      <Row styleRow="align-items:center;justify-content:space-between">
        <Title textone="Modules" texttwo="List" />
        <Button
          title="Add Module"
          icon={<Plus width={20} height={20} />}
          onClick={() => {
            navigate("/admin/modules/create");
          }}
        />
      </Row>
      <br />
      <Table
        hasSearchbar={false}
        columns={columns}
        data={modules || []}
        actions={[
          {
            key: "edit",
            icon: edit,
            onClick: (item) => {
              navigate(`/admin/modules/update/${item.id}`, { state: item });
            },
          },
          {
            key: "remove",
            icon: deletesvg,
            onClick: async (item) => {
              showModal(
                <DeleteModal
                  state={"modules"}
                  api={Module}
                  id={item.id}
                  onSuccess={() => fetchModules()}
                />,
              );
            },
          },
        ]}
      />
    </Container>
  );
};

export default ModuleList;
